/* MYNTELO 3D: iPhone 18 edition art (2026-10-16). A root with data-design-18 (myntelo.texture_3d_18, iPhone pages only; the liquid never sets it on a
   Galaxy page) shows that texture while the Model is iPhone 18 Pro / Pro Max and the standard one (data-design-std) for every other model. It only swaps
   data-design / data-design-hi and asks the boot to repaint (root._m3dDesign: 1024 first, the 2048 master as the upgrade), so try-on, colours and the
   poster flow are untouched. A home-card device switch to another product (root._m3dSwap) drops the 18 art; switching back to this product restores it. */
(function(){
  if(window.__m3d18) return; window.__m3d18=1;
  var IS18={'iPhone 18 Pro':1,'iPhone 18 Pro Max':1};
  var KEYS=['design-18','design-18-hi','design-std','design-std-hi'];
  function attr(r, k){ return r.getAttribute('data-'+k)||''; }
  function current(r){
    var scope=r.closest('.product, section, .shopify-section')||document;
    var sel=scope.querySelector('variant-selects select, variant-radios input:checked, select[name^="options"]');
    if(sel) return sel.value || '';   // v5.9: an empty "Choose your model" = no model yet: keep the standard art
    return r.dataset.model || '';
  }
  function apply(r, model){
    var a18=attr(r, 'design-18');
    if(!a18 || (r.dataset.family||'iphone')!=='iphone' || !/^iPhone /.test(model||'')) return;
    var src=IS18[model] ? a18 : attr(r, 'design-std'), hi=IS18[model] ? (attr(r, 'design-18-hi')||a18) : (attr(r, 'design-std-hi')||src);
    if(!src || r.dataset.design===src) return;
    r.dataset.design=src; r.dataset.designHi=hi;
    if(r._m3dDesign) r._m3dDesign();
  }
  function wrap(r){
    if(r._m3d18) return;
    var o=r._m3d18={handle:r.dataset.handle}; KEYS.forEach(function(k){ o[k]=attr(r, k); });
    var sw=r._m3dSwap;
    if(!sw) return;
    r._m3dSwap=function(cfg){
      var mine=cfg && cfg.handle ? cfg.handle===o.handle : r.dataset.handle===o.handle;
      if(mine){
        KEYS.forEach(function(k){ r.setAttribute('data-'+k, o[k]); });
        if(cfg && cfg.design) r.setAttribute('data-design-std', cfg.design);
        if(cfg && cfg.designHi) r.setAttribute('data-design-std-hi', cfg.designHi);
        if(cfg && IS18[cfg.model||'']){ cfg=Object.assign({}, cfg, {design:o['design-18'], designHi:o['design-18-hi']||o['design-18']}); }
      } else KEYS.forEach(function(k){ r.removeAttribute('data-'+k); });
      return sw(cfg);
    };
  }
  /* Gallery: the iPhone 18 Pro variant image (alt '... iPhone 18 edition art') is shown by Dawn's variant switch. A variant without its own image
     leaves it on screen, so for any other iPhone model the first original photo is made active again (Dawn's own setActiveMedia, moved to the front). */
  var ALT18=/iPhone 18 edition art/;
  function gallery(model){
    if(!/^iPhone /.test(model||'') || IS18[model]) return;
    document.querySelectorAll('media-gallery').forEach(function(g){
      var act=g.querySelector('.product__media-item.is-active img');
      if(!act || !ALT18.test(act.alt||'') || !g.setActiveMedia) return;
      var first=[].slice.call(g.querySelectorAll('.product__media-item')).filter(function(li){ var im=li.querySelector('img'); return im && !ALT18.test(im.alt||''); })[0];
      if(first) g.setActiveMedia(first.dataset.mediaId, true);
    });
  }
  function roots(){ return [].slice.call(document.querySelectorAll('[data-m3d][data-design-18]')); }
  function all(model){ var rs=roots(); rs.forEach(function(r){ apply(r, model||current(r)); }); if(rs.length) gallery(model||current(rs[0])); }
  document.addEventListener('change', function(e){ var v=e.target && e.target.value; if(v && /^iPhone /.test(v)) setTimeout(function(){ all(v); }, 0); });
  try{ if(window.subscribe) window.subscribe('variant-change', function(ev){ var v=ev && ev.data && ev.data.variant; if(v && v.option1) setTimeout(function(){ all(v.option1); }, 0); }); }catch(e){}
  document.addEventListener('m3d:ready', function(e){ var r=e.target; if(r && r.getAttribute && r.getAttribute('data-design-18')) apply(r, current(r)); });
  function init(){ var rs=roots(); rs.forEach(function(r){ wrap(r); apply(r, current(r)); }); if(rs.length) gallery(current(rs[0])); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
